/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiGroup, ApiUser } from '@Model';
import type { HttpActions, ListInfo, ListRequest, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of UsersGroupController.
 */
export class UsersGroupRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /users/{rootObjectId}/groups:query
     */
    public getLinkedObjects(listRequest: ListRequest, rootObjectId: string): Promise<Result<ListInfo<ApiGroup>>> {
        return this.http.post<Result<ListInfo<ApiGroup>>, ListRequest>(`/users/${rootObjectId}/groups:query`, listRequest);
    }

    /**
     * Calls POST /users/{rootObjectId}/groups:prefill
     */
    public createPrefilled(rootObjectId: string): Promise<Result<ApiGroup>> {
        return this.http.post<Result<ApiGroup>, undefined>(`/users/${rootObjectId}/groups:prefill`, undefined);
    }

    /**
     * Calls POST /users/{rootObjectId}/groups/linkable:query
     */
    public getLinkableObjects(listRequest: ListRequest, showAll: boolean, rootObjectId: string): Promise<Result<ListInfo<ApiGroup>>> {
        const query = new URLSearchParams();
        query.set('showAll', `${showAll}`);

        return this.http.post<Result<ListInfo<ApiGroup>>, ListRequest>(`/users/${rootObjectId}/groups/linkable:query`, listRequest, query);
    }

    /**
     * Calls POST /users/{rootObjectId}/groups
     */
    public addLinkedObject(id: string, rootObjectId: string): Promise<Result<ApiUser>> {
        const query = new URLSearchParams();
        query.set('id', `${id}`);

        return this.http.post<Result<ApiUser>, undefined>(`/users/${rootObjectId}/groups`, undefined, query);
    }

    /**
     * Calls DELETE /users/{rootObjectId}/groups/{unlinkId}
     */
    public deleteLinkedObject(unlinkId: string, rootObjectId: string): Promise<Result<ApiUser>> {
        return this.http.delete<Result<ApiUser>>(`/users/${rootObjectId}/groups/${unlinkId}`);
    }
}
